import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    LinearProgress, Link
} from "@material-ui/core";
import exportEntriesActions from "../../../reducers/exportEntries/exportEntriesActions";


const ExportDialog = props => {
    const {open, loading, errorMsg, handleClose, status} = props;
    const {exportData, error} = props;

    // only show progress bar if we are loading and there was no error
    const progress = (loading && !error) ? <LinearProgress /> : null;
    let message = null;
    let downloadLink = null;
    switch (status) {
        case exportEntriesActions.EXPORT_GENERATE_STARTED:
            message = "Please wait while the tournament entry list export is being generated.";
            break;
        case exportEntriesActions.EXPORT_GENERATE_ERROR:
            message = "An error occurred while generating the tournament entry list export: " + errorMsg;
            break;
        case exportEntriesActions.EXPORT_DOWNLOAD_SUCCESS:
            message = "Click on the link below to download the content";
            const exportUrl = window.URL.createObjectURL(exportData);
            downloadLink = <Link href={exportUrl} download="exportEntries.xlsx">Download</Link>
            break;
        default:
            break;
    }
    let dialogText = null;
    if (message != null) {
        dialogText = <DialogContentText>{message}</DialogContentText>;
    }

    return (
        <Dialog open={open} aria-labelledby="export-dialog-title">
            <DialogTitle id="export-dialog-title">Export Entries</DialogTitle>
            <DialogContent>
                {progress}
                {dialogText}
                {downloadLink}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );

}

export default ExportDialog;